import { shallowEqual } from "react-redux"
import { Message } from "@/reducers/messagesSlice"
import { MessageStatus } from "@/lib/messageHelpers"
import { useAppSelector } from "@/reducers/hooks"
import { messageStatuses } from "@/reducers/selectors"
import { selectActiveChat } from "@/reducers/chatsSliceSelectors"

function useMessageStatus(message: Message): MessageStatus | undefined {
  const activeChat = useAppSelector(selectActiveChat)
  const statuses = useAppSelector(messageStatuses(activeChat), shallowEqual)

  return statuses[message.id]
}

export default useMessageStatus
